<fui-pill-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" (focussed$)="focus()"
                 [hovered]="hovered">
    <fui-fixtures>
        @if (!disabled) {
            <fui-fixture>
                <fui-icon [height]="12" [icon]="'calendar'" [width]="12"
                          [clickable]="true" (click)="toggle($event)"></fui-icon>
            </fui-fixture>
        }
        <fui-fixture>
            <fui-pill-label [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                            [title]="label"></fui-pill-label>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom>
                <kendo-dateinput #input [(ngModel)]="value" (focus)="onFocus($event)" (blur)="onBlur($event)"
                                 [placeholder]="inputPlaceholder | translate" [format]="'dd/MM/yyyy'"
                                 [disabled]="disabled" [tabindex]="tabindex"></kendo-dateinput>
            </fui-input-dom>
        </fui-spanning-fixture>
        <fui-fixture>
            <fui-mark-button (click)="remove()">
                <fui-icon [height]="6" [icon]="'close'" [width]="6"></fui-icon>
            </fui-mark-button>
        </fui-fixture>
    </fui-fixtures>
</fui-pill-fascia>
<fui-date-pop [popped]="popped" (popped$)="pop($event)" (click)="popClicked($event)">
    @if (popped) {
        <kendo-calendar #calendar [(ngModel)]="value" (valueChange)="calendarChanged($event)"></kendo-calendar>
    }
</fui-date-pop>
